import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'rumio_recently_viewed';
const MAX_ITEMS = 20;

interface RecentItem {
  id: string;
  slug: string;
  name: string;
  price: number;
  image_url?: string;
  viewedAt: number;
}

export function useRecentlyViewed() {
  const [items, setItems] = useState<RecentItem[]>(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
      // Storage full or unavailable
    }
  }, [items]);

  const addItem = useCallback((product: { id: string; slug: string; name: string; price: number; image_url?: string }) => {
    setItems((prev) => {
      const filtered = prev.filter((i) => i.id !== product.id);
      return [{ ...product, viewedAt: Date.now() }, ...filtered].slice(0, MAX_ITEMS);
    });
  }, []);

  const getItems = useCallback((excludeId?: string, max?: number) => {
    let result = items;
    if (excludeId) result = result.filter((i) => i.id !== excludeId);
    if (max) result = result.slice(0, max);
    return result;
  }, [items]);

  return { items, addItem, getItems };
}
